import moment from 'moment';

export const getMessageTime = () => {
  return moment().utc().format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
};

export const getLocalizedtime = (timespan) => {
  return moment(timespan).format('MMM-DD-YYYY, hh:mm A');
};

export const getCurrentDate = () => {
  return moment().format('MM-DD-YYYY');
};

export const getCurrentTime = () => {
  return moment().format('hh:mm A');
};